import { useMediaQuery } from "@mui/material"

const useIsTablet = () => {
  return useMediaQuery("(min-width:650px) and (max-width:1024px)")
}

export default useIsTablet
